<template>
    <v-dialog v-model="dialog"
              max-width="600px"
              scrollable
    >
        <template v-slot:activator="{ on }">
            <slot v-bind:on="on"/>
        </template>
        <v-card class="modal-card">
            <v-card-title class="pa-6">Новое сообщение</v-card-title>
            <ValidationObserver ref="form" tag="div">
                <v-card-text class="pa-6">
                    <v-alert type="info" dense>Сообщение может быть отправлено только клиентам подключившимся к Viber
                        боту или
                        Telegram боту
                    </v-alert>

                    <v-row>
                        <v-col cols="12" class="pb-0">
                            <ValidationProvider name="recipients"
                                                rules="required"
                                                v-slot="{ errors }"
                                                tag="div"
                                                class="client-info-group">
                                <v-autocomplete
                                        v-model="recipients"
                                        :items="recipientsList"
                                        item-text="name"
                                        item-value="id"
                                        required
                                        label="Получатели"
                                        outlined
                                        :error-messages="errors"
                                        multiple
                                        small-chips
                                        deletable-chips
                                        @change="onRecipientChange"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pb-0">
                            <ValidationProvider
                                    name="text"
                                    rules="required"
                                    v-slot="{ errors }"
                                    tag="div"
                                    class="client-info-group">
                                <v-textarea
                                        name="text"
                                        label="Текст сообщения"
                                        v-model="text"
                                        clearable
                                        outlined
                                        :error-messages="errors"
                                        auto-grow
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                </v-card-text>
            </ValidationObserver>
            <v-card-actions class="px-6 py-5">
                <v-spacer></v-spacer>
                <v-btn depressed dark color="blue-grey" @click="close" min-width="120" class="mx-2">Закрыть</v-btn>
                <v-btn depressed color="success" @click="save" min-width="120">Отправить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import messageApi from '../api/message.api';
    import {mapState} from "vuex";

    export default {
        name    : "MessageCreateDialog",
        props   : {
            to: {
                required: false
            }
        },
        data() {
            return {
                dialog    : false,
                recipients: [],
                text      : '',
            }
        },
        computed: {
            ...mapState({
                clientsState: state => state['clients'].items,
            }),
            clients() {
                return [{id: 'all', name: 'Всем'}, {id: 'lost', name : 'Потерянным'}].concat(this.clientsState);
            },
            recipientsList() {
                return this.clients.filter((client) => client.viber_id || client.telegram_id || 'all' === client.id || 'lost' === client.id);
            }
        },
        watch   : {
            dialog(value) {
                if (true === value) {
                    if (this.to && false === this.recipients.includes(this.to)) {
                        this.recipients.push(this.to);
                    }
                } else {
                    //reset
                    this.$refs.form.reset();
                }
            }
        },
        created() {

        },
        methods : {
            async save() {
                if (false === await this.$refs.form.validate()) {
                    return;
                }

                this.$store.commit('setLoading', true);
                messageApi.create({
                    recipients: this.recipients,
                    text      : this.text,
                }).then(() => {
                    this.$emit('sent');
                    this.recipients = [];
                    this.text = '';
                    this.close();
                }).catch(({response}) => {
                    this.$refs.form.setErrors(response.data.errors);
                }).finally(() => {
                    this.$store.commit('setLoading', false);
                });
            },
            close() {
                this.dialog = false;
            },
            onRecipientChange() {
                if (this.recipients.includes('all')) {
                    this.recipients.length = 0;
                    this.recipients.push('all');
                }
            },
        }
    }
</script>

<style scoped>

</style>
